export { default as DynamicComponentTabs } from "./DynamicComponentTabs";
